import * as type from "./constants";

export const getStageAllocators = (payload) => {
  return {
    type: type.GET_STAGE_ALLOCATOR_ACTION,
    payload,
  };
};
